"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE_PATTERN = void 0;
exports.validatePhone = validatePhone;
/**
 * Validates Mexican phone number format
 * Phone is optional - undefined/null/empty string are valid
 *
 * @param value - Phone to validate
 * @returns ValidationResult with isValid flag and optional error message
 */
function validatePhone(value) {
    // Phone is optional, undefined/null is valid
    if (value === undefined || value === null) {
        return { isValid: true };
    }
    const trimmed = value.trim();
    // Empty string is also valid (optional field)
    if (trimmed === '') {
        return { isValid: true };
    }
    // Mexican phone: 10 digits
    const phonePattern = /^\d{10}$/;
    if (!phonePattern.test(trimmed)) {
        return { isValid: false, error: 'Teléfono inválido. Debe tener 10 dígitos' };
    }
    return { isValid: true };
}
/**
 * Regex pattern for phone validation (10 digits)
 * Can be used directly in form libraries that accept regex
 */
exports.PHONE_PATTERN = /^\d{10}$/;
